import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { MonitoreoProfesionalesContent } from './components/MonitoreoProfesionalesContent';

export default function GestionProfesionales() {

    return (
        <>
            <MainContent
                component={<MonitoreoProfesionalesContent />}
                titulo={'Monitoreo de Profesionales'}
                noBackground
                tableMaxWidth
            />
        </>
    );
};
